import moment from 'moment/moment';

export const toDuration = (dateStart: string, dateEnd: string): moment.Duration => {
    const start = moment(dateStart);
    const end = moment(dateEnd);
    const duration = moment.duration(end.diff(start));

    return duration;
};
